import { hasIn, includes, split } from 'lodash';
// import "whatwg-fetch"; // Polyfill per fetch su IE11

const _normalizeUrl = (url) => {
  if (!window.location.origin) {
    window.location.origin =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');
  }
  return window.location.origin + $pathBase + url;
};

const get = async function ({ url, headers = {} }) {
  const mergedHeaders = {
    ...{
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      // mode: 'no-cors', // no-cors, cors, *same-origin
      // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'max-age=15',
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      // redirect: 'follow', // manual, *follow, error
      // referrer: 'no-referrer', // no-referrer, *client
      // body: JSON.stringify(data), // body data type must match "Content-Type" header
    },
    ...headers,
  };
  url = _normalizeUrl(url);
  return fetch(url, mergedHeaders)
    .then((response) => {
      if (response.status >= 400 && response.status < 600) {
        const errorMessage = hasIn(response, 'statusText')
          ? response.statusText
          : 'Bad response from server';
        // throw new Error( errorMessage );
        throw { status: response.status, errorMessage };
      } else if (response.redirected) {
        if (includes(response.url.toLowerCase(), 'logon?returnurl')) {
          const returnUrl = encodeURIComponent(
            split(window.location.toString(), window.location.origin)[1],
          );
          window.location = `${
            split(response.url, '?')[0]
          }?returnUrl=${returnUrl}`;
          return;
        }
        window.location = response.url;
        return;
      }
      return response;
    })
    .then((returnedResponse) => {
      // Your response to manipulate
      return includes(
        returnedResponse.headers.get('Content-Type'),
        'application/json',
      )
        ? returnedResponse.json()
        : returnedResponse;
    })
    .catch((error) => {
      // Your error is here!
      if (error.status && error.status === 500) {
        // console.error(error);
        throw `Error on GET (status ${error.status}) url ${url}: ${error.errorMessage}`;
      }
      throw `Error on GET url ${url}: ${error}`;
    });
};

const getExternal = async function ({ url, headers = {} }) {
  const mergedHeaders = {
    ...{
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      // mode: 'no-cors', // no-cors, cors, *same-origin
      // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'max-age=15',
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      // redirect: 'follow', // manual, *follow, error
      // referrer: 'no-referrer', // no-referrer, *client
      // body: JSON.stringify(data), // body data type must match "Content-Type" header
    },
    ...headers,
  };
  return fetch(url, mergedHeaders)
    .then((response) => {
      if (response.status >= 400 && response.status < 600) {
        const errorMessage = hasIn(response, 'statusText')
          ? response.statusText
          : 'Bad response from server';
        // throw new Error( errorMessage );
        throw { status: response.status, errorMessage };
      }
      return response;
    })
    .then((returnedResponse) => {
      // Your response to manipulate
      return includes(
        returnedResponse.headers.get('Content-Type'),
        'application/json',
      )
        ? returnedResponse.json()
        : returnedResponse;
    })
    .catch((error) => {
      // Your error is here!
      if (error.status && error.status === 500) {
        // console.error(error);
        throw `Error on GET (status ${error.status}) url ${url}: ${error.errorMessage}`;
      }
      throw `Error on GET url ${url}: ${error}`;
    });
};

const postFormData = async function ({ url, body }) {
  url = _normalizeUrl(url);
  const response = await fetch(url, {
    method: 'POST',
    body: body,
  });
  return response;
};

const post = async function ({ url, body = {} }) {
  url = _normalizeUrl(url);
  const rawResponse = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (rawResponse.redirected) {
    if (includes(rawResponse.url.toLowerCase(), 'logon?returnurl')) {
      const returnUrl = encodeURIComponent(
        split(window.location.toString(), window.location.origin)[1],
      );
      window.location = `${
        split(rawResponse.url, '?')[0]
      }?returnUrl=${returnUrl}`;
      return {};
    }
    window.location = rawResponse.url;
    return {};
  }

  const content = await rawResponse.json();
  return content;
};

const remove = async function ({ url, headers = {} }) {
  url = _normalizeUrl(url);
  return fetch(url, {
    ...{
      method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      headers: {
        'Content-Type': 'application/json',
      },
    },
    ...headers,
  })
    .then((returnedResponse) => {
      return includes(
        returnedResponse.headers.get('Content-Type'),
        'application/json',
      )
        ? returnedResponse.json()
        : returnedResponse;
    })
    .catch((error) => {
      if (error.status && error.status === 500) {
        throw `Error on DELETE (status ${error.status}) url ${url}: ${error.errorMessage}`;
      }
      throw `Error on DELETE url ${url}: ${error}`;
    });
};

export { get, getExternal, postFormData, post, remove };
